"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _button = require("@jsluna/button");

var _modal = require("@jsluna/modal");

var _Chrome = _interopRequireDefault(require("../assets/Chrome.png"));

var _Firefox = _interopRequireDefault(require("../assets/Firefox.png"));

var _IE = _interopRequireDefault(require("../assets/IE.png"));

var _Opera = _interopRequireDefault(require("../assets/Opera.png"));

var _Safari = _interopRequireDefault(require("../assets/Safari.png"));

var _browser = _interopRequireWildcard(require("./browser"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var UnsupportedBrowser = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(UnsupportedBrowser, _React$Component);

  function UnsupportedBrowser() {
    var _this;

    _this = _React$Component.call(this) || this;
    _this.state = {
      showModal: false
    };
    _this.handleClose = _this.handleClose.bind(_assertThisInitialized(_this));
    return _this;
  } // eslint-disable-next-line camelcase


  var _proto = UnsupportedBrowser.prototype;

  _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
    this.setState({
      showModal: (0, _browser.default)()
    });
  };

  _proto.handleClose = function handleClose() {
    this.setState({
      showModal: false
    }, function () {
      (0, _browser.setBrowserCheckHasBeenCompletedCookie)();
    });
  };

  _proto.render = function render() {
    var showModal = this.state.showModal;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_modal.Modal, {
      handleClose: function handleClose() {},
      setHasOverlay: function setHasOverlay() {},
      open: showModal,
      hideCloseButton: true
    }, /*#__PURE__*/_react.default.createElement("h1", {
      className: "primary-header ln-u-color-orange ln-u-text-align-center"
    }, "You're flying solo!"), /*#__PURE__*/_react.default.createElement("div", {
      className: "unsupported-content"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "unsupported-images"
    }, /*#__PURE__*/_react.default.createElement("img", {
      className: "unsupported-content-image",
      src: _Chrome.default,
      alt: "chrome"
    }), /*#__PURE__*/_react.default.createElement("img", {
      className: "unsupported-content-image",
      src: _Safari.default,
      alt: "safari"
    }), /*#__PURE__*/_react.default.createElement("img", {
      className: "unsupported-content-image",
      src: _Firefox.default,
      alt: "firefox"
    }), /*#__PURE__*/_react.default.createElement("img", {
      className: "unsupported-content-image",
      src: _IE.default,
      alt: "ie"
    }), /*#__PURE__*/_react.default.createElement("img", {
      className: "unsupported-content-image",
      src: _Opera.default,
      alt: "opera"
    })), /*#__PURE__*/_react.default.createElement("h5", {
      className: "ln-u-soft-top ln-u-soft-sides"
    }, "Your browser isn't supported, or is too old, but ..."), /*#__PURE__*/_react.default.createElement("p", {
      className: "ln-u-soft-sides"
    }, 'You can continue using your browser, ', 'without some features and cool stuff being available and it may not work as desired. ', 'Or you can get the best experience by using a supported browser.'), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_button.FilledButton, {
      className: "unsupported-content-confirm-button",
      onClick: this.handleClose
    }, "Ok got it"))));
  };

  return UnsupportedBrowser;
}(_react.default.Component);

var _default = UnsupportedBrowser;
exports.default = _default;